// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerWithIcon_container__1WHDV","banner":"BannerWithIcon_banner__2DCjb","iconContainer":"BannerWithIcon_iconContainer__WgYbc","title":"BannerWithIcon_title__H3xVk"};